<template>
  <div align-center justify-center style="font-family: 'Kanit', sans-serif" class="mb-12">
    <v-row no-gutters class="pt-10">
      <v-col cols="1" md="1" xs="1" sm="1"></v-col>
      <v-col cols="10" md="11" xs="10" sm="10">
        <v-row no-gutters>
          <v-col cols="12" md="6" xs="12" sm="12">
            <!-- <v-img src="@/assets/Image.png"></v-img> -->
            <v-col cols="1" md="1" xs="1" sm="1"></v-col>
            <div class="video-lobby">
              <video id="vid" width="100%" height="100%" style="border-radius: 20px;"
                :muted="!showHeart || micVolume === 0" :class="{ 'video-muted': !clickvideo }">
                Your browser does not support the video tag.
              </video>
              <div v-if="cameraLoading" class="video-loading-overlay">
                <v-progress-circular indeterminate color="white" size="48" />
                <span class="video-loading-text">{{ $t("message.loadingCamera") }}</span>
              </div>
              <div v-else-if="cameraBlocked" class="video-permission-overlay">
                <v-icon class="video-permission-icon" color="white">mdi-video-off-outline</v-icon>
                <span class="video-permission-text">{{ $t("message.cameraBlocked") }}</span>
              </div>
              <div v-else-if="!clickvideo" class="video-off-overlay">
                <v-icon class="video-off-icon" color="white">mdi-video-off</v-icon>
                <span class="video-off-text">{{ $t("message.cameraOff") }}</span>
              </div>
              <div class="video-button" v-if="!cameraLoading && !cameraBlocked && !loading">
                <v-btn depressed fab class="video-action-btn" @click="closeAudio">
                  <v-icon v-if="!clickvoice">mdi-microphone-off</v-icon>
                  <v-icon v-else>mdi-microphone</v-icon>
                </v-btn>
                <v-btn depressed fab class="video-action-btn" @click="closeVideo">
                  <v-icon v-if="!clickvideo">mdi-video-off</v-icon>
                  <v-icon v-else>mdi-video</v-icon>
                </v-btn>
                <v-menu v-if="$vuetify.breakpoint.width > 500" v-model="audioMenu" offset-y
                  transition="scale-transition" :close-on-content-click="false" min-width="260">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed fab class="video-action-btn" v-bind="attrs" v-on="on">
                      <v-icon>mdi-microphone-settings</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="device-dropdown-card">
                    <div class="device-dropdown-header">
                      <v-icon small color="#5865F2" class="mr-2">mdi-microphone-settings</v-icon>
                      <span>{{ $t('message.micSelect') }}</span>
                    </div>
                    <v-divider />
                    <v-list dense class="device-dropdown-list">
                      <v-list-item v-for="option in selectAudioDevices" :key="option" @click="selectAudioDevice(option)"
                        :class="{ 'is-active': audioDevices === option }">
                        <v-list-item-icon>
                          <v-icon v-if="audioDevices === option" color="#5865F2">mdi-check</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ option }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="!selectAudioDevices.length" disabled>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{
                              $t('message.noDevices') !== 'message.noDevices'
                                ? $t('message.noDevices')
                                : 'No devices found'
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
                <v-menu v-if="$vuetify.breakpoint.width > 500" v-model="videoMenu" offset-y
                  transition="scale-transition" :close-on-content-click="false" min-width="260">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed fab class="video-action-btn" v-bind="attrs" v-on="on">
                      <v-icon>mdi-video-switch</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="device-dropdown-card">
                    <div class="device-dropdown-header">
                      <v-icon small color="#5865F2" class="mr-2">mdi-video-outline</v-icon>
                      <span>{{ $t('message.camSelect') }}</span>
                    </div>
                    <v-divider />
                    <v-list dense class="device-dropdown-list">
                      <v-list-item v-for="option in selectVideoDevices" :key="option" @click="selectVideoDevice(option)"
                        :class="{ 'is-active': videoDevices === option }">
                        <v-list-item-icon>
                          <v-icon v-if="videoDevices === option" color="#5865F2">mdi-check</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ option }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="!selectVideoDevices.length" disabled>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{
                              $t('message.noDevices') !== 'message.noDevices'
                                ? $t('message.noDevices')
                                : 'No devices found'
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
                <!-- Test Mic -->
                <!-- <v-menu v-if="$vuetify.breakpoint.width > 500" v-model="micTestMenu" offset-y
                  transition="scale-transition" :close-on-content-click="false" min-width="320">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed fab class="video-action-btn" v-bind="attrs" v-on="on">
                      <v-icon>mdi-microphone-check</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="mic-test-dropdown-card">
                    <div class="mic-test-dropdown-header">
                      <v-icon small color="#5865F2" class="mr-2">mdi-microphone-check</v-icon>
                      <div>
                        <div class="mic-test-dropdown-title">{{ $t('message.checkMic') }}</div>
                      </div>
                    </div>
                    <v-divider class="my-3" />
                    <div class="mic-test-dropdown-body">
                      <div class="mic-volume-column">
                        <span class="mic-volume-value">{{ micVolume }}</span>
                        <v-slider v-model="micVolume" class="mic-volume-slider" min="0" max="200" step="1"
                          color="#5865F2" track-color="#2c2f3b" thumb-label @input="onMicVolumeChange"></v-slider>
                        <span class="mic-volume-label">{{ micVolumeLabel }}</span>
                      </div>
                      <div class="mic-visualizer mic-visualizer-popup"
                        :class="{ 'is-active': microphoneCheckActive || showHeart }">
                        <div v-if="showHeart" class="mic-visualizer-live">
                          <audio ref="player"></audio>
                          <av-media class="av-media-style" type="frequ" :media="media" :line-width="2"
                            line-color="#5865F2" :canv-width="micCanvasWidth" :bar-length="3" :line-space="2" />
                        </div>
                        <div v-else class="mic-visualizer-idle">
                          <span v-for="bar in micLevelBars" :key="bar" class="mic-visualizer-idle-bar"
                            :style="micBarStyle(bar)"></span>
                        </div>
                      </div>
                    </div>
                    <div class="mic-test-dropdown-actions">
                      <v-btn block class="mic-test-button" :class="{ 'is-active': showHeart }" color="#5865F2" dark
                        rounded depressed :loading="microphoneCheckActive" :disabled="microphoneCheckActive" height="44"
                        @click="checkMicrophone">
                        <v-icon left small>mdi-microphone-check</v-icon>
                        {{ $t('message.checkMic') }}
                      </v-btn>
                    </div>
                  </v-card>
                </v-menu> -->
              </div>
            </div>
            <div class="toggle-switch-wrapper">
              <label class="toggle-switch">
                <input type="checkbox" v-model="switchEnabled">
                <span class="toggle-track">
                  <span class="toggle-label-on">ON</span>
                  <span class="toggle-label-off">OFF</span>
                  <span class="toggle-thumb"></span>
                </span>
              </label>
              <span class="toggle-text-label" :class="{ 'is-on': switchEnabled }">
                {{ switchEnabled ? 'เปิดพื้นหลังที่ใช้ล่าสุด' : 'ปิดพื้นหลังที่ใช้ล่าสุด' }}
              </span>
            </div>
          </v-col>

          <v-col md="1"></v-col>

          <v-col cols="12" md="5" xs="12" sm="12" class="pb-6" align-self="center">
            <v-row no-gutters class="ml-2 mb-4">
              <v-row no-gutters class="ml-2 mb-4" v-if="namecompany !== ''">
                <v-col cols="2" md="2" sm="2" xs="3" class="mr-6">
                  <v-img :src="logo" max-width="90px" max-height="100px"></v-img>
                </v-col>
                <v-col cols="8" md="6" sm="9" xs="8" align-self="center">
                  <v-row>
                    <span style="
                        font-family: 'Noto Sans';
                        font-size: 24px;
                        font-weight: 550;
                        color: #353535;
                      ">{{ namecompany }}</span>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters class="ml-2 mb-4" v-if="namecompany === ''">
                <v-col cols="1" md="1" sm="1" xs="3"></v-col>
                <v-col cols="8" md="8" sm="8" xs="8" class="mr-6">
                  <v-img :src="logo" max-width="150px" max-height="150px"></v-img>
                </v-col>
              </v-row>
            </v-row>
            <div v-if="this.checkstart" style="
                  font-family: 'Kanit';
                  font-size: 28px;
                  font-weight: 1000;
                  line-height: 55.46px;
                  letter-spacing: -1.7%;
                " class="mt-1">
              {{ $t("message.readymeeting") }}
            </div>
            <div v-if="!this.checkstart" style="
                  color: crimson;
                  font-family: 'Kanit';
                  font-size: 28px;
                  font-weight: 1000;
                  line-height: 55.46px;
                  letter-spacing: -1.7%;
                " class="mt-1">
              ! {{ $t("button.notstartyet") }}
            </div>
            <div style="
                  font-family: 'Kanit';
                  font-weight: 600;
                  color: #faad14;
                " class="pb-2">
              <span>{{ $t("roomsetting.roomname") }} : </span>
              <span>{{ meetingName }}</span>
            </div>
            <div style="
                  font-family: 'Kanit';
                  font-weight: 600;
                  color: #faad14;
                ">
              <span>{{ $t("roomsetting.typeroom") }} : </span>
              <span v-if="chkSecretRoom === true">{{ $t("roomsetting.secretmeeting") }}</span>
              <span v-if="chkSecretRoom === false">{{ $t("roomsetting.normalmeeting") }}</span>
            </div>
            <div style="
                  font-family: 'Kanit';
                  font-weight: 600;
                  color: #faad14;
                " class="pt-2">
              <span>{{ $t("loginpage.Invitedby") }} : </span>
              <span>{{ hostName }}</span>
            </div>
            <div style="
                  font-family: 'Kanit';
                  font-weight: 600;
                " class="pt-2">
              <span>{{ $t("loginpage.name") }} : </span>
              <span>{{ firstname }}</span>
            </div>
            <div class="mt-3" v-if="showpass === true">
              <v-row no-gutters>
                <v-col cols="12" md="2" sm="12" xs="12" align-self="center" class="mt-n4"
                  style="font-family: 'Kanit'; font-weight: 600">
                  <span>{{ $t("roomsetting.pass") }} : </span>
                </v-col>
                <v-col cols="12" md="8" sm="12" xs="12" align-self="center" class="mt-2"
                  style="font-family: 'Kanit'; font-weight: 600">
                  <v-text-field solo dense :disabled="loading" background-color="#EDEDED"
                    v-model.trim="Passroom" @input="removeSpaces" @keydown="blockSpacebar"></v-text-field>
                </v-col>
              </v-row>
            </div>
            <!-- <v-row no-gutters>
                <v-col
                  cols="12"
                  md="2"
                  sm="12"
                  xs="12"
                  align-self="center"
                  class=""
                >
                  <span>{{$t("roomsetting.videoquality") }} : </span>
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                  sm="12"
                  xs="12"
                  align-self="center"
                  class="mt-4"
                >
                  <v-select
                    :items="itemsvideo"
                    v-model="datavideo"
                    placeholder="Up to 2464kbps"
                    solo
                    dense
                    background-color="#EDEDED"
                  ></v-select>
                </v-col>
              </v-row> -->
            <v-row no-gutters v-if="!loading">
              <v-col cols="12" md="10" sm="12" xs="12" class="mt-2">
                <v-menu v-if="!this.checkstart">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn @click="getdatalobbyjoin" v-bind="attrs" v-on="{ ...tooltip, ...menu }" min-width="100%"
                          rounded color="#DCDCDC">
                          <v-icon class="pr-1">mdi-logout-variant</v-icon> {{ $t("button.attendmeeting") }}
                        </v-btn>
                      </template>
                      <span>! {{ stateSchedule ? $t("button.notstartyet") : $t("button.notstartyet") }}</span>
                    </v-tooltip>
                  </template>
                </v-menu>
                <div>
                  <v-btn v-if="this.checkstart" @click="checkstartroom" min-width="100%" rounded color="#3D85C6"
                    style="color: white" dark>
                    <template v-if="!loading">
                      <v-icon class="pr-1">mdi-logout-variant</v-icon> {{ $t("button.attendmeeting") }}</template>
                    <template v-if="loading">
                      <span>รอการอนุมัติ</span>
                      <v-icon class="custom-loader">mdi-cached</v-icon>
                    </template>
                  </v-btn>
                </div>
              </v-col>
              <!-- <v-col md="2"></v-col> -->
              <v-col cols="12" md="10" sm="12" xs="12" align-self="center" class="mt-2">
                <div>
                  <v-btn @click="notjoinroom" min-width="100%" rounded color="error" dark>
                    <v-icon class="pr-1">mdi-progress-close</v-icon> {{ $t("button.didnmeeting") }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="loading">
              <v-col cols="12" md="10" sm="12" xs="12" class="mt-n2">
                <div style="display: flex; justify-content: center; font-weight: 600">
                  <span class="pr-1" style="font-size: 20px; color: #04449f;">{{ $t("loginpage.waiting") }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="loading">
              <v-col cols="12" md="10" sm="12" xs="12" class="mt-n2">
                <div style="display: flex; justify-content: center; font-weight: 600">
                  <span style="font-size: 18px; color: #04449f;">{{ $t("loginpage.waitingHost") }}
                  </span>
                </div>
              </v-col>
            </v-row>
            <!-- <div class="pt-10">
                <v-btn @click="checkstartroom" min-width="100%" rounded color="primary" dark>
                  <v-icon class="pr-1">mdi-logout-variant</v-icon> เข้าร่วมการประชุม
                </v-btn>
              </div> -->
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1" md="1" xs="1" sm="1"></v-col>
    </v-row>

    <!-- Dialog Device -->
    <v-dialog v-model="setDialogDevice" width="600px">
      <v-card>
        <v-card-title style="font-size: 28px; font-weight: 500">
          Devices
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-row no-gutters>
          <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="5" class="pr-2">
            <v-select v-model="audioDevices" :items="selectAudioDevices" label="Audio" outlined></v-select>
          </v-col>
          <v-col cols="12" sm="5" class="pl-2">
            <v-select v-model="videoDevices" :items="selectVideoDevices" label="Video" outlined></v-select>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeDialog">
            {{ $t("button.didnmeeting") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { uuid } from 'uuidv4';
const sign = require('jwt-encode');
const secret = 'secret';
var Centrifuge = require('centrifuge')
var centrifuge = new Centrifuge(process.env.VUE_APP_CENTRIFUGE_LIVEKIT)
// import { mapActions } from 'vuex'
// import { mdiLogoutVariant } from '@mdi/js';

export default {
  mounted() {
    this.onMicVolumeChange(this.micVolume)
    if (localStorage.getItem('user-token') === null) {
      this.$swal
        .fire({
          title: this.$t("message.nomeeting"),
          // text: 'กรุณาเข้าสู่ระบบ',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: this.$t("button.btnok"),
          allowOutsideClick: false
        }).then(res => {
          // window.location.href = '/'
          this.$router.push({ path: '/' + '?uuid=' + this.$route.query.uuid }).catch(() => { })
        }
        )
    } else {
      // const audio = this.$refs.player
      // const constraints = {
      //   audio: true,
      //   video: false
      // }
      // navigator.mediaDevices.getUserMedia(constraints).then(media => {
      //   this.media = media
      //   audio.srcObject = media
      //   // media.active = this.clickvoice
      // })
      this.decodejwttoken()
      // this.connectCentrifuge()
      // this.$router.push({ path: '/lobbyJoin' + '/?uuid=' + this.uuid, params: { schedule: 1 } }).catch(() => {})
      this.getMedia()
      // this.getAudioWave()
      this.getDevice()
      this.setuuid()
    }
  },
  beforeDestroy() {
    this.stopMicrophoneCheck && this.stopMicrophoneCheck()
    this.stopStream && this.stopStream(this.media)
    this.stopMediaTracks && this.stopMediaTracks()
  },
  data() {
    return {
      datavideo: '',
      datavideo1: '',
      checkstart: false,
      typeroom: '',
      clickvideo: false,
      clickvoice: false,
      loading: false,
      cameraLoading: false,
      cameraBlocked: false,
      selectedAudioDeviceId: null,
      selectedVideoDeviceId: null,
      microphoneCheckActive: false,
      micTestTimer: null,
      micVolume: 100,
      micTestExpanded: false,
      audioMenu: false,
      videoMenu: false,
      micTestMenu: false,
      deviceLabelMap: {
        audio: {},
        video: {},
      },
      datavideo2: 2464,
      itemsvideo: [
        'Up to 512kbps',
        'Up to 768kbps',
        'Up to 1024kbps',
        'Medium (Up to 1264kbps)',
        'Up to 1500kbps',
        'High (Up to 2464kbps)',
        'Very High (Up to 6144kbps)'
      ],
      meetingName: '',
      namecompany: '',
      logo: '',
      profile: null,
      user_id: '',
      meetingidlogo: '',
      hostName: '',
      chkSecretRoom: false,
      marker: true,
      urlJoin: '',
      showHeart: false,
      Passroom: '',
      showpass: false,
      mediaStream: null,
      jwt: require('jsonwebtoken'),
      stateVideo: false,
      stateAudio: false,
      media: null,
      dataroom: '',
      firstname: '',
      setDialogDevice: false,
      txtLink: '',
      videoDevices: '',
      loader: null,
      audioDevices: '',
      selectAudioDevices: [],
      selectVideoDevices: [],
      uuid_video: '',
      uuid_audio: '',
      conference_type: '',
      access_onechat: '',
      refresh_onechat: '',
      roueuid: '',
      stateSchedule: false,
      switchEnabled: false,
    }
  },
  created() {
    //   console.log('this.$route.query.uuid', this.$route.query.uuid)
    this.roueuid = this.$route.query.uuid
    if (this.$route.query.uuid === undefined) {
      window.location.href = '/'
    }
    this.getDevice()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
      if (from.name !== 'otp') {
        window.location.href = '/'
      }
    })
  },
  computed: {
    micLevelBars() {
      const breakpoint = this.$vuetify && this.$vuetify.breakpoint
      const totalBars = breakpoint && breakpoint.smAndDown ? 18 : 32
      return Array.from({ length: totalBars }, (_, index) => index)
    },
    micCanvasWidth() {
      const breakpoint = this.$vuetify && this.$vuetify.breakpoint
      if (breakpoint && breakpoint.smAndDown) {
        return 240
      }
      return 360
    },
    micVolumeLabel() {
      if (typeof this.$t === 'function') {
        const translated = this.$t('message.micVolume')
        if (translated && translated !== 'message.micVolume') {
          return translated
        }
      }
      return 'Microphone Volume'
    },
    micTestDescription() {
      if (typeof this.$t === 'function') {
        const translated = this.$t('message.micTestDescription')
        if (translated && translated !== 'message.micTestDescription') {
          return translated
        }
      }
      return "Having mic issues? Start a test and say something fun - we'll play your voice back to you."
    },
    devicePanelTitle() {
      if (typeof this.$t === 'function') {
        const translated = this.$t('message.deviceSetup')
        if (translated && translated !== 'message.deviceSetup') {
          return translated
        }
      }
      return 'Device setup'
    },
  },
  methods: {
    blockSpacebar(e) {
      if (e.key === ' ' || e.keyCode === 32) {
        e.preventDefault();
        return false;
      }
    },
    removeSpaces(e) {
      if (typeof this.Passroom === 'string') {
        this.Passroom = this.Passroom.replace(/\s+/g, '');
      }
    },
    toggleMicTestPanel() {
      this.micTestExpanded = !this.micTestExpanded
    },
    micBarStyle(index) {
      const total = this.micLevelBars.length || 1
      const progress = total > 1 ? index / (total - 1) : 0
      const delay = (index % 10) * 0.14
      const duration = 2 + (index % 6) * 0.2
      const height = 12 + Math.sin(progress * Math.PI) * 18
      return {
        height: `${Math.max(height, 10).toFixed(0)}px`,
        animationDelay: `${delay.toFixed(2)}s`,
        animationDuration: `${duration.toFixed(2)}s`
      }
    },
    onMicVolumeChange(value) {
      const level = typeof value === 'number' ? value : this.micVolume
      const normalized = Math.min(Math.max(level / 100, 0), 1)
      this.applyMicVolumeToStream(this.mediaStream, normalized)
      this.applyMicVolumeToStream(this.media, normalized)
      const videoElement = document.getElementById('vid')
      if (videoElement) {
        videoElement.volume = normalized
      }
    },
    selectAudioDevice(option) {
      this.audioDevices = option
      this.onAudioDeviceChange()
      this.audioMenu = false
    },
    selectVideoDevice(option) {
      this.videoDevices = option
      this.onVideoDeviceChange()
      this.videoMenu = false
    },
    applyMicVolumeToStream(stream, normalizedVolume) {
      if (!stream || typeof normalizedVolume !== 'number') {
        return
      }
      const volumeValue = Math.min(Math.max(normalizedVolume, 0), 1)
      stream.getAudioTracks().forEach((track) => {
        if (typeof track.applyConstraints === 'function') {
          track
            .applyConstraints({
              advanced: [{ volume: volumeValue }]
            })
            .catch(() => {
              /* ignore unsupported constraints */
            })
        }
      })
    },
    setuuid() {
      sessionStorage.setItem("uuid", uuid())
    },
    openDialogDevice() {
      this.setDialogDevice = true
    },
    setStateAudio() {
      this.stateAudio = !this.stateAudio
    },
    setStateVideo() {
      this.stateVideo = !this.stateVideo
      this.getMedia({ preserveState: true })
    },
    decodejwttoken() {
      this.refrestoken()
      var token = localStorage.getItem('user-token')
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, '')
      var data = this.jwt.decode(decryptedText)
      this.userData = data
      this.getdatalobbyjoin()
      // console.log('this.userData', this.userData.user)
      this.user_id = this.userData.user._id
      if (data.user.lastname === '') {
        this.firstname = data.user.email
        this.lastname = ''
      } else {
        this.firstname = data.user.name
        this.lastname = data.user.lastname
      }
    },
    connectCentrifuge(data, jwt, uid) {
      var me = this
      var events = ''
      var data_msg = ''
      // console.log('me.room_id: ', me.room_id)
      centrifuge.setToken(process.env.VUE_APP_CENTRIFUGE_KEYLIVEKIT);
      // centrifuge.subscribe(`message-room-${me.room_id}-member-${me.member_detail.member_id}`, function(message) {
      //   // console.log(message)
      //   me.insertMessage(message.data, message.data.message_id)
      // })
      centrifuge.subscribe(`accecpt-${data}`, function (ctx) {
        // console.log(ctx.data);
        if (ctx.data.service_type === 'conference') {
          if (ctx.data.uuid === uid) {
            const deeplink = process.env.VUE_APP_WEBRTC + '/conference/join/' + jwt;
            window.location.href = deeplink;
            this.loading = false
          }
          // window.open(process.env.VUE_APP_WEBRTC + '/conference/join/' + jwt , '_self')
          // this.loading = false
        } else if (ctx.data.service_type === 'reject') {
          if (ctx.data.uuid === uid) {
            this.loading = false
            me.$swal('คุณถูกปฏิเสธ การเข้าห้องประชุม', '', 'warning').then(res => {
              me.$router.push({ path: '/' }).catch(() => { })
            })
          }
        } else {
          console.log('waitting');
        }
        // if(ctx.data.service_type === 'conference') {
        //   window.open(process.env.VUE_APP_WEBRTC + '/conference/join/' + jwt , '_self')
        //   this.loading = false
        // } else {
        //   this.loading = false
        //   me.$swal('คุณถูกปฏิเสธ การเข้าห้องประชุม','', 'warning').then(res => {
        //   me.$router.push({ path: '/' }).catch(() => {})})
        // }
      });
      centrifuge.subscribe(`accecpt-all-${data}`, function (ctx) {
        console.log(ctx.data);
        const participant = ctx.data.find((item) => item.uuid === uid);
        console.log(participant);
        if (participant.service_type === "conference") {
          if (participant.uuid === uid) {
            this.loading = false
            const deeplink = process.env.VUE_APP_WEBRTC + '/conference/join/' + jwt;
            window.location.href = deeplink;
          }
        } else if (participant.service_type === "reject") {
          if (participant.uuid === uid) {
            this.loading = false;
            me.$swal("คุณถูกปฏิเสธ การเข้าห้องประชุม", "", "warning").then((res) => {
              me.$router.push({ path: "/" }).catch(() => { });
            });
          }
        } else {
          console.log("waitting");
        }
      });
      centrifuge.on('connect', function () {
        console.log("connected");
      });
      centrifuge.on('disconnect', function () {
        console.log("disconnected");
      });
      centrifuge.connect();
    },
    async refrestoken() {
      var token = localStorage.getItem('user-token')
      await this.axios.get(process.env.VUE_APP_API + '/api/lv1/auth/refreshtoken',
        {
          headers: {
            Authorization: "bearer " + localStorage.getItem('user-token'),
          },
        }
      ).then(res => {
        // console.log('sssss', res)
      }).catch(err => {
        this.$swal(this.$t("message.Sessiontimeout"), '', 'warning').then(result => {
          localStorage.clear()
          localStorage.setItem("lang", "th")
          window.open('/join' + '?uuid=' + this.$route.query.uuid, '_self')
        })
      })
    },
    getdatalobbyjoin() {
      this.uuid = this.$route.query.uuid
      // console.log('uuid', this.uuid)
      this.axios.get(process.env.VUE_APP_API + '/api/lv1/join/check/' + this.uuid).then(res => {
        if (res.data.result === 'Success') {
          if (res.data.message === 'This meeting room is not started yet.') { //host not start yet
            this.checkstart = false
            this.stateSchedule = false
          } else if (res.data.message === 'This meeting room is not time for started yet.') { //
            this.checkstart = false
            this.stateSchedule = true
          } else {
            this.checkstart = true
          }
          this.dataroom = JSON.parse(this.decodeJS(res.data.data))
          // console.log('dataroom', this.dataroom)
          // console.log('/api/v1/join/check/', this.dataroom)
          this.meetingidlogo = this.dataroom.meeting_id
          this.meetingName = this.dataroom.roomname
          this.typeroom = this.dataroom.setting.type
          // console.log('res Success', this.dataroom)
          this.hostName = this.dataroom.fullname
          if (this.dataroom.pass_key === '123roominet!') {
            this.showpass = false
          } else {
            this.showpass = true
          }
          if (this.dataroom.setting.login === true && this.dataroom.setting.secretroom === false) {
            this.chkSecretRoom = false
          } else if (this.dataroom.setting.login === false && this.dataroom.setting.secretroom === false) {
            this.chkSecretRoom = false
          } else {
            this.chkSecretRoom = true
          }
          // this.getlogo()
        } else {
          console.log('NO Success', res.data.result)
        }
      })
        .catch(err => {
          if (err?.response?.data?.message === 'No meeting room.') {
            this.$swal(this.$t("message.nomeeting"), this.$t("message.tryagain"), "warning").then(
              res => {
                this.$router.push({ path: "/joinpage" }).catch(() => { });
              }
            );
          }
          // console.log('NO Success', err.data.message)
        })
    },
    getlogo() {
      this.axios.get(process.env.VUE_APP_API + '/api/v1/theme/getlogo/' + this.meetingidlogo).then(res => {
        // console.log('res', res.data.data.logo)
        this.logo = res.data.data.logo.logo
        // this.avatar = res.data.data.user.profile
        this.namecompany = res.data.data.logo.name
        // if(logo === ''){
        //   if(namecompany === '')

        // }
      }).catch(err => {
        console.log('err getlogo', err)
      })
    },
    decodeJS(data) {
      try {
        var bytes = this.CryptoJS.AES.decrypt(data, process.env.VUE_APP_SECRET_KEY)
        var decryptedData = JSON.parse(bytes.toString(this.CryptoJS.enc.Utf8))
        return decryptedData
      } catch (error) {
        console.log('>>>>>>>>', error)
        return error
      }
    },
    notjoinroom() {
      window.location.href = '/'
    },
    async getDevice() {
      await navigator.mediaDevices.enumerateDevices().then((devices) => {
        this.devices = devices
        const audioDevices = devices.filter(
          (device) => device.kind === 'audioinput'
        )
        const videoDevices = devices.filter(
          (device) => device.kind === 'videoinput'
        )
        this.updateDeviceCollections(audioDevices, videoDevices)
      })
    },
    getMedia(options = {}) {
      const { preserveState = false } = options
      this.cameraLoading = true
      this.cameraBlocked = false
      if (!preserveState) {
        // this.clickvoice = true
        // this.clickvideo = true
        this.showHeart = false
      }

      const videoPlaysInLine = document.getElementById('vid')
      if (videoPlaysInLine) {
        videoPlaysInLine.setAttribute('playsinline', true)
      }

      const audioConstraint = this.selectedAudioDeviceId
        ? { deviceId: { exact: this.selectedAudioDeviceId } }
        : true

      const videoConstraint = { width: 1280, height: 650 }
      if (this.selectedVideoDeviceId) {
        videoConstraint.deviceId = { exact: this.selectedVideoDeviceId }
      }

      this.stopMediaTracks()

      const constraints = {
        audio: audioConstraint,
        video: videoConstraint,
      }

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((mediaStream) => {
          const videoElement = document.getElementById('vid')
          this.mediaStream = mediaStream
          this.cameraBlocked = false

          mediaStream.getAudioTracks().forEach((track) => {
            track.enabled = this.clickvoice
          })
          mediaStream.getVideoTracks().forEach((track) => {
            track.enabled = this.clickvideo
          })
          this.applyMicVolumeToStream(mediaStream, this.micVolume / 100)

          if (videoElement) {
            videoElement.srcObject = mediaStream
            videoElement.volume = Math.min(Math.max(this.micVolume / 100, 0), 1)
            const attemptPlay = videoElement.play()
            if (attemptPlay && typeof attemptPlay.finally === 'function') {
              attemptPlay.finally(() => {
                this.cameraLoading = false
              })
            } else {
              this.cameraLoading = false
            }
            videoElement.onplaying = () => {
              this.cameraLoading = false
            }
          } else {
            this.cameraLoading = false
          }

          this.getAudioWave()
        })
        .catch((err) => {
          console.log(err.name + ': ' + err.message)
          this.cameraBlocked =
            err &&
            (err.name === 'NotAllowedError' || err.name === 'SecurityError' || err.name === 'PermissionDeniedError')
          if (this.cameraBlocked) {
            this.clickvideo = false
            if (!this.clickvoice) {
              this.showHeart = false
            }
          }
          this.cameraLoading = false
        })
    },
    closeVideo() {
      if (this.clickvideo === false) {
        if (this.mediaStream) {
          this.mediaStream.getTracks().forEach(function (track) {
            // track.stop()
            if (track.kind === 'video') {
              track.enabled = true
            }
          })
        }
      } else {
        if (this.mediaStream) {
          this.mediaStream.getTracks().forEach(function (track) {
            // track.stop()
            if (track.kind === 'video') {
              track.enabled = false
            }
          })
        }
      }
      this.clickvideo = !this.clickvideo
    },
    closeAudio() {
      this.clickvoice = !this.clickvoice
      // console.log('this.clickvoice', this.clickvoice)
    },

    // getMedia() {
    //   const constraints = { video: { width: 1280, height: 650 } }
    //   const videoPlaysInLine = document.getElementById('vid')
    //   videoPlaysInLine.setAttribute('playsinline', true)
    //   const vm = this
    //   navigator.mediaDevices
    //     .getUserMedia(constraints)
    //     .then(function (mediaStream) {
    //       const video = document.querySelector('video')
    //       vm.mediaStream = mediaStream
    //       video.srcObject = mediaStream

    //       video.onloadedmetadata = function (e) {
    //         video.play()
    //       }
    //       if (this.stateVideo === true) {
    //         video.srcObject.getTracks().forEach(function (track) {
    //           track.stop()
    //         })
    //         vm.mediaStream.getTracks().forEach(function (track) {
    //           track.stop()
    //         })
    //       }
    //     })
    //     .catch(function (err) {
    //       console.log(err.name + ': ' + err.message)
    //     })
    // },
    getAudioWave(forceShow = false) {
      const constraints = {
        audio: this.selectedAudioDeviceId
          ? { deviceId: { exact: this.selectedAudioDeviceId } }
          : true,
        video: false,
      }

      return navigator.mediaDevices
        .getUserMedia(constraints)
        .then((media) => {
          this.stopStream(this.media)
          this.media = media
          this.applyMicVolumeToStream(media, this.micVolume / 100)
          if (forceShow) {
            this.showHeart = true
          }
          return media
        })
        .catch((err) => {
          console.log('getAudioWave', err.name + ': ' + err.message)
          if (forceShow) {
            this.microphoneCheckActive = false
          }
        })
    },
    stopStream(stream) {
      if (!stream) {
        return
      }
      stream.getTracks().forEach((track) => track.stop())
    },
    stopMediaTracks(kinds = null) {
      if (!this.mediaStream) {
        return
      }
      this.mediaStream.getTracks().forEach((track) => {
        if (!kinds || kinds.includes(track.kind)) {
          track.stop()
        }
      })
      if (!kinds) {
        this.mediaStream = null
      }
    },
    resolveDeviceId(kind, label) {
      if (!label || !this.devices) {
        return null
      }
      const map = kind === 'audioinput' ? this.deviceLabelMap.audio : this.deviceLabelMap.video
      if (map && map[label]) {
        return map[label]
      }
      const match = this.devices.find(
        (device) => device.kind === kind && device.label === label
      )
      return match ? match.deviceId : null
    },
    syncSelectedDeviceIds() {
      this.selectedAudioDeviceId = this.resolveDeviceId('audioinput', this.audioDevices)
      this.selectedVideoDeviceId = this.resolveDeviceId('videoinput', this.videoDevices)
      this.uuid_audio = this.selectedAudioDeviceId || ''
      this.uuid_video = this.selectedVideoDeviceId || ''
    },
    onAudioDeviceChange() {
      this.syncSelectedDeviceIds()
      this.restartMediaStream()
      this.getAudioWave()
    },
    onVideoDeviceChange() {
      this.syncSelectedDeviceIds()
      this.restartMediaStream()
    },
    restartMediaStream() {
      if (this.cameraBlocked) {
        this.cameraBlocked = false
      }
      this.getMedia({ preserveState: true })
    },
    updateDeviceCollections(audioDevices, videoDevices) {
      const audioMap = {}
      const videoMap = {}

      this.selectAudioDevices = audioDevices.map((device, index) => {
        const label = device.label || this.$t('message.micFallback', { index: index + 1 })
        audioMap[label] = device.deviceId
        return label
      })

      this.selectVideoDevices = videoDevices.map((device, index) => {
        const label = device.label || this.$t('message.camFallback', { index: index + 1 })
        videoMap[label] = device.deviceId
        return label
      })

      this.deviceLabelMap.audio = audioMap
      this.deviceLabelMap.video = videoMap

      if (!this.audioDevices || !audioMap[this.audioDevices]) {
        this.audioDevices = this.selectAudioDevices[0] || ''
      }

      if (!this.videoDevices || !videoMap[this.videoDevices]) {
        this.videoDevices = this.selectVideoDevices[0] || ''
      }

      this.syncSelectedDeviceIds()
    },
    checkMicrophone() {
      if (this.showHeart === false) {
        this.getAudioWave()
        if (this.mediaStream) {
          this.mediaStream.getTracks().forEach(function (track) {
            if (track.kind === 'audio') {
              track.enabled = true
            }
          })
        }
        this.showHeart = true
      } else {
        this.mediaStream.getTracks().forEach(function (track) {
          if (track.kind === 'audio') {
            track.enabled = false
          }
        })
        this.showHeart = false
      }
    },
    stopMicrophoneCheck() {
      if (this.micTestTimer) {
        clearTimeout(this.micTestTimer)
        this.micTestTimer = null
      }
      this.microphoneCheckActive = false
      if (!this.clickvoice) {
        this.showHeart = false
      }
    },

    closeDialog() {
      this.syncSelectedDeviceIds()
      this.restartMediaStream()
      this.getAudioWave()
      this.setDialogDevice = false
    },
    checkstartroom() {
      this.refrestoken()
      // console.log('res Success', this.dataroom)
      if (this.datavideo === 'Up to 512kbps') {
        this.datavideo1 = '512'
        this.datavideo2 = 512
      } else if (this.datavideo === 'Up to 768kbps') {
        this.datavideo1 = '768'
        this.datavideo2 = 768
      } else if (this.datavideo === 'Up to 1024kbps') {
        this.datavideo1 = '1024'
        this.datavideo2 = 1024
      } else if (this.datavideo === 'Medium (Up to 1264kbps)') {
        this.datavideo1 = '1264'
        this.datavideo2 = 1264
      } else if (this.datavideo === 'Up to 1500kbps') {
        this.datavideo1 = '1500'
        this.datavideo2 = 1500
      } else if (this.datavideo === '' || this.datavideo === 'High (Up to 2464kbps)') {
        this.datavideo1 = '2464'
        this.datavideo2 = 2464
      } else if (this.datavideo === 'Very High (Up to 6144kbps)') {
        this.datavideo1 = '6144'
        this.datavideo2 = 6144
      }
      // console.log('res Success', this.dataroom)
      if (this.dataroom.pass_key !== '123roominet!') {
        if (this.Passroom === '') {
          // this.$swal('กรุณาใส่ "ระบุรหัสผ่านห้องประชุม"', '', 'warning')
          this.$swal(this.$t("loginpage.Pleasespecify"), this.$t("loginpage.password"), 'warning')
        } else {
          var password = this.Passroom + ':inet!'
          // console.log('res passeord', password)
          if (this.dataroom.pass_key !== password) {
            // this.$swal('ระบุรหัสผ่านห้องประชุม "ไม่ถูกต้อง"', '', 'warning')
            this.$swal(this.$t("loginpage.nopass"), 'warning')
          } else {
            this.checkweb(this.Passroom)
          }
        }
      } else {
        this.checkweb(this.Passroom)
      }
    },
    checkweb(data) {
      this.joinOnechat(data)
      // if (this.dataroom.setting.type === 'onertc') {
      //   // this.joinOnechat(data)
      //   this.getDeviceCamera(data)
      // } else {
      // this.startRoomwebapp(data)
      // }
    },
    startRoomwebapp(data) {
      // console.log('data',data)
      this.axios.post(process.env.VUE_APP_API + '/api/lv1/join/joinlogin',
        {
          uid: this.uuid,
          key: data
        })
        .then(res => {
          // console.log('startRoomwebapp', res.data)
          if (res.data.result === 'Join Success') {
            var onechat = {
              access_onechat: this.access_onechat,
              refresh_onechat: this.refresh_onechat,
              token: res.data.data,
              devices: {
                video_mute: !this.clickvideo,
                audio_mute: !this.clickvoice,
                video_bandwidth: this.datavideo2,
              },
              user_id: this.userData.user.oneid,
              useBgDefault: this.switchEnabled
            }
            // var joinsuccess = JSON.parse(this.decodeJS(res.data.data))
            // console.log('joinsuccess', onechat)
            const jwt = sign(onechat, secret);
            // console.log('jwt', jwt)
            this.meetcreate()
            this.waitingroom(jwt)
            this.loading = true
            // window.open(process.env.VUE_APP_WEBRTC + '/conference/join/' + jwt , '_self')
            // const decryptedText = this.CryptoJS.AES.decrypt(
            //   joinsuccess,
            //   process.env.VUE_APP_SECRET_KEY
            // )
            //   .toString(this.CryptoJS.enc.Utf8)
            //   .replace(/"/g, '')
            // console.log('joinsuccess', decryptedText)
          }
        })
        .catch(err => {
          console.log('startRoomwebapp', err)
          // this.$swal(err,'warning', 'warning')
          this.$swal(this.$t("message.nomeeting") + this.$t("roomsetting.or") + this.$t("message.roomnotopened"), "", 'warning')
          this.loading = false
        })
    },
    meetcreate() {
      this.axios.post(process.env.VUE_APP_API + '/api/lv1/meet/create', {
        meeting_id: this.dataroom.meeting_id
      }).then((res) => {
        // console.log('res meetingcreate' ,res)
      }).catch((err) => {
        console.log(err)
      })
    },
    waitingroom(jwt) {
      // console.log(' waitingroom jw', this.dataroom)
      this.axios.post(process.env.VUE_APP_API + '/api/lv1/activity/waitingroom',
        {
          uuid: this.dataroom.meeting_id,
          participant: {
            participantname: this.firstname + " " + this.lastname,
            role: "guest",
            uuid: sessionStorage.getItem("uuid")
          }
        }).then((res) => {
          // console.log('waitingroom', res.data.message.data)
          if (res.data.message.data.service_type === 'conference') {
            const deeplink = process.env.VUE_APP_WEBRTC + '/conference/join/' + jwt;
            window.location.href = deeplink;
            this.loading = false
          } else {
            this.requestaccept(res.data.message.data, jwt)
          }
        })
    },
    requestaccept(data, jwt) {
      // console.log(' requestaccept jw', data)
      this.axios.post(process.env.VUE_APP_API + '/api/lv1/activity/requestaccept',
        {
          uuid: this.dataroom.meeting_id,
          participant: {
            uuid: data.uuid,
            service_type: data.service_type,
            participantname: data.participantName,
            role: data.role
          }
        }).then((res) => {
          // console.log('waitingroom', res)
          this.connectCentrifuge(this.dataroom.meeting_id, jwt, data.uuid)
          // if(res.data.message.data === 'conference'){
          //   // window.open(process.env.VUE_APP_WEBRTC + '/conference/join/' + jwt , '_self')
          // } else {
          //   this.requestaccept()
          // }
        })
    },
    joinOnechat(data) {
      this.axios.post(process.env.VUE_APP_API_ONECHAT + '/backend/api/v1/member/join',
        {
          room_id: this.dataroom.meeting_id,
          user_id: this.userData.user.oneid,
          user_name: this.firstname + " " + this.lastname,
          user_profile: 'https://www.shareicon.net/data/512x512/2016/05/24/770117_people_512x512.png',
          user_role: "member"
        }, {
        headers: { Authorization: `Bearer ${this.dataroom.onechat.access_onechat}` }
      }
      )
        .then((result) => {
          const dataOneChat = result.data.data
          // console.log('createOneChat', dataOneChat)
          this.access_onechat = dataOneChat.access_token
          this.refresh_onechat = dataOneChat.refresh_token
          this.startRoomwebapp(data)
          // this.getDeviceCamera(data)
        })
        .catch((err) => {
          console.log('error', err)
        })
    },
    async getDeviceCamera(data) {
      await navigator.mediaDevices.enumerateDevices().then((devices) => {
        this.devices = devices
        const audioDevices = devices.filter(
          (device) => device.kind === 'audioinput'
        )
        const videoDevices = devices.filter(
          (device) => device.kind === 'videoinput'
        )
        this.updateDeviceCollections(audioDevices, videoDevices)
        this.startRoomwebrtc(data)
      }).catch(() => {
        this.startRoomwebrtc(data)
      })
    },
    async startRoomwebrtc(data) {
      if (this.videoDevices === '') {
        this.conference_type = 'audioonly'
      } else {
        this.conference_type = ''
      }
      await this.axios
        .post(
          process.env.VUE_APP_API + '/api/v1/rtc/anonymouse/generate-token',
          {
            video_mute: !this.clickvideo,
            audio_mute: !this.clickvoice,
            uid_video: this.uuid_video,
            uid_audio: this.uuid_audio,
            // uid_video: this.videoDevices,
            // uid_audio: this.audioDevices,
            room_id: this.dataroom.setting.onechat.room_id,
            video_bandwidth: this.datavideo2,
            profile: this.user_id,
            conference_type: this.conference_type,
            meeting_id: this.dataroom.meeting_id,
            room_name: this.dataroom.roomname,
            user_name: this.userData.user.name + " " + this.userData.user.lastname,
            oneid: this.userData.user.oneid,
            url_guest: process.env.VUE_APP_DOMAIN + '/join/?uuid=' + this.uuid,
            access_token_oneid: localStorage.getItem('access-token'),
            access_token: this.dataroom.setting.onechat.access_onechat,
            refresh_token: this.refresh_onechat,
            role: 'Guest',
            alias: this.dataroom.setting.pexip.aliases[0].alias,
            guest_pin: this.dataroom.setting.pexip.guest_pin,
            uid: this.uuid,
            key: data
          }
        )
        .then((result) => {
          const data = result.data.data
          // console.log('res', data)
          window.open(
            process.env.VUE_APP_PEXIP + 'room/join/' + data.token,
            '_self'
          )
        })
        .catch((err) => {
          this.$swal(err.response.data.message, 'warning', 'warning')
        })
    }
  },
  watch: {
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => this[l] = true)

      this.loader = null
    },
  }
}
</script>

<style scoped lang="css">
@import url("https://fonts.googleapis.com/css?family=Noto+Sans:400,700,400italic,700italic&subset=latin,latin-ext");
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200&display=swap");

.toggle-switch-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
}

.toggle-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  line-height: 0;
  margin-bottom: 0;
}

.toggle-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-track {
  display: inline-flex;
  align-items: center;
  width: 64px;
  height: 30px;
  border-radius: 30px;
  background-color: #ccd0de;
  position: relative;
  transition: background-color 0.3s ease;
  box-shadow: inset 0 1px 4px rgba(0, 0, 0, 0.1);
}

.toggle-switch input:checked + .toggle-track {
  background-color: #3d85c6;
}

.toggle-thumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  top: 4px;
  left: 4px;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  z-index: 1;
}

.toggle-switch input:checked + .toggle-track .toggle-thumb {
  transform: translateX(34px);
}

.toggle-label-on,
.toggle-label-off {
  position: absolute;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.5px;
  pointer-events: none;
  user-select: none;
  transition: opacity 0.2s;
}

.toggle-label-on {
  color: white;
  left: 14px;
  opacity: 0;
}

.toggle-label-off {
  color: #9098b1;
  right: 12px;
  opacity: 1;
}

.toggle-switch input:checked + .toggle-track .toggle-label-on {
  opacity: 1;
}

.toggle-switch input:checked + .toggle-track .toggle-label-off {
  opacity: 0;
}

.toggle-text-label {
  font-family: 'Kanit', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #9098b1;
  transition: color 0.2s;
}

.toggle-text-label.is-on {
  color: #3d85c6;
}

body {
  font-family: "Noto Sans", sans-serif;
  font-weight: 400;
  /* font-weight: 700; */
}

.video-lobby {
  position: relative;
  overflow: hidden;
}

.video-muted {
  filter: grayscale(100%);
  opacity: 0.35;
}

.video-off-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  text-align: center;
  pointer-events: none;
  border-radius: 20px;
  z-index: 10;
}

.video-off-icon {
  font-size: 48px;
  margin-bottom: 4px;
}

.video-off-text {
  font-family: "Kanit", sans-serif;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.video-permission-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: calc(20px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  text-align: center;
  pointer-events: none;
  border-radius: 20px;
  z-index: 15;
}

.video-permission-icon {
  font-size: 52px;
  margin-bottom: 6px;
}

.video-permission-text {
  font-family: "Kanit", sans-serif;
  font-weight: 600;
  letter-spacing: 0.4px;
  max-width: 80%;
}

.video-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: calc(20px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  text-align: center;
  border-radius: 20px;
  z-index: 20;
  pointer-events: none;
}

.video-loading-text {
  margin-top: 12px;
  font-family: "Kanit", sans-serif;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.video-button {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  transform: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 0 24px;
  z-index: 30;
}

.video-action-btn {
  width: 56px;
  height: 56px;
  background: rgba(20, 23, 35, 0.72) !important;
  color: rgba(255, 255, 255, 0.92) !important;
  border: 1px solid rgba(88, 101, 242, 0.18);
  box-shadow: 0 14px 26px rgba(8, 10, 18, 0.45);
  transition: background 0.2s ease, transform 0.2s ease;
}

.video-action-btn ::v-deep .v-icon {
  font-size: 26px;
}

.video-action-btn:hover {
  background: rgba(35, 39, 55, 0.92) !important;
  transform: translateY(-2px);
}

.device-dropdown-card {
  background: rgba(17, 19, 28, 0.95);
  border-radius: 16px;
  padding: 12px 0;
  color: #ffffff;
  box-shadow: 0 18px 34px rgba(9, 11, 18, 0.6);
  border: 1px solid rgba(88, 101, 242, 0.12);
}

.device-dropdown-header {
  display: flex;
  align-items: center;
  padding: 0 20px 8px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.35px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.8);
}

.device-dropdown-list {
  max-height: 220px;
  overflow-y: auto;
}

.device-dropdown-list .v-list-item {
  min-height: 44px;
}

.device-dropdown-list .v-list-item.is-active {
  background: rgba(88, 101, 242, 0.16);
}

.device-dropdown-list .v-list-item-title {
  color: rgba(255, 255, 255, 0.92);
  font-weight: 500;
}

.device-dropdown-list ::v-deep .v-list-item__icon {
  margin-right: 12px;
}

.mic-test-dropdown-card {
  background: rgba(17, 19, 28, 0.95);
  border-radius: 16px;
  padding: 16px 18px;
  color: #ffffff;
  box-shadow: 0 20px 36px rgba(9, 11, 18, 0.6);
  border: 1px solid rgba(88, 101, 242, 0.12);
}

.mic-test-dropdown-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.mic-test-dropdown-title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.mic-test-dropdown-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.5;
  margin-top: 2px;
}

.mic-test-dropdown-body {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
}

.mic-volume-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
}

.mic-volume-value {
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
}

.mic-volume-slider {
  width: 100%;
  max-width: 260px;
}

.mic-volume-slider ::v-deep .v-slider__track-container {
  height: 4px;
}

.mic-volume-slider ::v-deep .v-slider__thumb {
  box-shadow: 0 3px 10px rgba(88, 101, 242, 0.45);
}

.mic-test-dropdown-actions {
  margin-top: 4px;
}

.mic-visualizer-popup {
  width: 100%;
  min-height: 88px;
  padding: 12px;
  flex: 1 1 auto;
}

.mic-visualizer-popup .mic-visualizer-live ::v-deep canvas {
  height: 34px !important;
}

.mic-volume-label {
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.72);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.av-media-style {
  width: 100%;
  opacity: 0.9;
}

.mic-test-card {
  margin-top: 18px;
  padding: 20px;
  border-radius: 16px;
  background: linear-gradient(135deg, #1f2333 0%, #1b1e2b 100%);
  box-shadow: 0 10px 30px rgba(18, 21, 33, 0.35);
  color: #ffffff;
}

.mic-test-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
}

.mic-test-toggle {
  color: #ffffff !important;
}

.mic-test-toggle ::v-deep .v-icon {
  color: inherit !important;
}

.mic-test-body {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.mic-test-text {
  margin-bottom: 0;
}

.mic-test-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0;
}

.mic-test-description {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.5;
}

.volume-controls {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
}

.volume-control {
  background: rgba(20, 23, 35, 0.6);
  border-radius: 12px;
  padding: 12px;
  box-shadow: inset 0 0 0 1px rgba(88, 101, 242, 0.08);
}

.volume-control-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: rgba(255, 255, 255, 0.78);
  margin-bottom: 6px;
}

.volume-label {
  flex: 1;
}

.volume-value {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
}

.volume-slider {
  margin: 0;
}

.volume-slider ::v-deep .v-slider__thumb {
  box-shadow: 0 4px 12px rgba(88, 101, 242, 0.45);
}

.volume-slider ::v-deep .v-slider__track-container {
  height: 6px;
}

.mic-test-action {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
}

.mic-test-button {
  padding: 0 20px;
  font-weight: 600;
  letter-spacing: 0.2px;
  text-transform: none;
}

.mic-test-button.is-active {
  background-color: #f44336 !important;
  border-color: #f44336 !important;
  color: #ffffff !important;
}

.mic-visualizer {
  flex: 1 1 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 10px 16px;
  border-radius: 12px;
  background: rgba(31, 35, 51, 0.88);
  border: 1px solid rgba(88, 101, 242, 0.2);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.02);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.mic-visualizer.is-active {
  border-color: rgba(88, 101, 242, 0.75);
  box-shadow: 0 0 22px rgba(88, 101, 242, 0.32);
  background: rgba(40, 44, 66, 0.95);
}

.mic-visualizer-live {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
}

.mic-visualizer-live audio {
  display: none;
}

.mic-visualizer-live ::v-deep canvas {
  width: 100% !important;
  height: 36px !important;
}

.mic-visualizer-idle {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
  min-height: 32px;
  height: 32px;
}

.mic-visualizer-idle-bar {
  width: 6px;
  flex: 0 0 6px;
  border-radius: 3px;
  background: linear-gradient(180deg, rgba(136, 145, 189, 0.5) 0%, rgba(78, 84, 112, 0.45) 100%);
  opacity: 0.7;
  animation-name: micIdlePulse;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  transform-origin: bottom;
}

.mic-visualizer.is-active .mic-visualizer-idle-bar {
  background: rgba(88, 101, 242, 0.85);
}

@keyframes micIdlePulse {

  0%,
  100% {
    transform: scaleY(0.5);
    opacity: 0.4;
  }

  50% {
    transform: scaleY(1);
    opacity: 0.9;
  }
}
</style>
